module.exports = __webpack_public_path__ + "files/84bbbd6d6f56d1659791c2c7b992b927.png";